import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Checkbox, Field, ControlGroup } from "@conserveit/blocks";
import { connect } from "react-redux";
import DynamicFormComponent from "./DynamicFormComponent";
import { CONTEXT_LIST } from "../../../utils/lists";

@connect(
  (state) => ({
    isFormDisabled: state.reportGenerator.isFormDisabled,
  }),
  null,
  null,
  { forwardRef: true }
)
export default class IssueContextCheckBox extends DynamicFormComponent {
  static propTypes = {
    isFormDisabled: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { selectedContexts: CONTEXT_LIST };
  }

  handleCheckboxChange = (issueContext) => {
    const updatedContexts = [...this.state.selectedContexts];
    const index = updatedContexts.indexOf(issueContext);

    if (index > -1) {
      updatedContexts.splice(index, 1);
    } else {
      updatedContexts.push(issueContext);
    }

    this.setState({ selectedContexts: updatedContexts });
  };

  validate = () => true;

  getSelectedValues = () => {
    return { issueContextList: this.state.selectedContexts };
  };

  render() {
    return (
      <Field label="Context" name="reportContext">
        {() => (
          <ControlGroup vertical>
            {CONTEXT_LIST.map((issueContext) => (
              <Checkbox
                label={issueContext}
                checked={this.state.selectedContexts.includes(issueContext)}
                disabled={this.props.isFormDisabled}
                onChange={() => this.handleCheckboxChange(issueContext)}
                key={issueContext}
              />
            ))}
          </ControlGroup>
        )}
      </Field>
    );
  }
}
